import * as authService from 'ls-common-client/dist/auth';
import config from '../../src/client/config';
import logger from './logger';

const { auth, token: configToken } = config;

const serverDefaults = {
  login: () => {},
  logout: () => {},
  token: () => {},
  init: () => {},
};

const instance =
  typeof window !== 'undefined'
    ? authService.create({
        auth,
        token: configToken,
        logger,
      })
    : serverDefaults;

const { login, logout, token, init } = instance;

export { login, logout, token, init };

export default instance;
